/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface I18NTranslationsRetrieve$Params {
  /**
   * Идентификатор локали
   */
  locale: string;
}

export function i18NTranslationsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: I18NTranslationsRetrieve$Params,
  context?: HttpContext,
): Observable<
  BakendHttpResponse<{
    [key: string]: any;
  }>
> {
  const rb = new RequestBuilder(rootUrl, i18NTranslationsRetrieve.PATH, 'get');
  if (params) {
    rb.query('locale', params.locale, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<{
        [key: string]: any;
      }>;
    }),
  );
}

i18NTranslationsRetrieve.PATH = '/api/i18n/translations/';
